require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-andrew-sinner.json") })
        }
      }, "path---blog-author-andrew-sinner");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-andrew-sinner!./.cache/json/blog-author-andrew-sinner.json
// module id = 602
// module chunks = 231608221292675